import * as type from '../actions/types';

const initialState = {
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.END_GOAL_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.END_GOAL_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
      };
    case type.END_GOAL_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
